/* @flow */

import React, { useEffect, useState } from "react";
import { useTranslate } from "@awardit/react-use-translate";
import cn from "classnames";
import { useData } from "crustate/react";
import { QuoteData } from "data";
import CartIcon from "@material-ui/icons/ShoppingCartOutlined";

import styles from "./styles.scss";

type Props = {
  className: string,
  isOpen: boolean,
  openMiniCart: () => void,
  children: React$Node,
};

const CartCounter = ({ className = "", isOpen, openMiniCart, children }: Props): React$Node => {
  const t = useTranslate();
  const data = useData(QuoteData);
  const quote = data.state === "LOADED" ? data.data : {};
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    if (data.state !== "LOADED") {
      return;
    }

    setCartCount(quote.items.reduce((a, { qty }) => {
      a += qty;
      return a;
    }, 0));
  }, [data, quote]);

  if (cartCount > 0) {
    return (
      <button
        type="button"
        aria-label={t("CART.OPEN_CART_WITH_ITEMS", { itemsCount: cartCount })}
        className={cn(
          styles.block,
          { [styles.active]: isOpen },
          className
        )}
        onClick={() => openMiniCart()}
      >
        <div className={styles.iconWrapper}>
          <CartIcon />
          <span className={styles.cartCount}>{cartCount}</span>
        </div>
        {children}
      </button>
    );
  }

  return (
    <div className={cn(styles.block, className)}>
      <div className={styles.iconWrapper}>
        <CartIcon />
      </div>

      {children}
    </div>
  );
};

export default CartCounter;
